module.exports = __webpack_public_path__ + "static/placeholdersquare-ae2aeb91b2ed63044083d6c74cf40261.png";